import { InvitationResource } from '../../Store/Types';
import { findLink } from '../../../../../../LinkyLinky';
import ModalStore from '../../../../../Modal/Store';
import { T } from '../../../../../../Translations';
import InvitationStore from '../../Store/InvitationStore';
import { Maybe } from 'maybeasy';

interface Props {
  store: InvitationStore;
  resource: InvitationResource;
  modalStore: ModalStore;
}

export const deactivateLink = ({ store, resource, modalStore }: Props): Maybe<React.ReactNode> => {
  const handleClick = () => {
    store.confirmingDeactivate(resource);
    modalStore.open();
  };

  return findLink('deactivate', resource.links).map((_link) => (
    <span className="px-2.5 py-4 cursor-pointer" onClick={handleClick}>
      <T kind="Remove Collection Access" />
    </span>
  ));
};
